import React from "react";
import "./giftcards.css";
import { motion } from "framer-motion";

function GiftCards() {
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 1 } },
    exit: { opacity: 0, y: -20, transition: { duration: 1 } },
  };

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="gift-cards">
        <h1>Coming Soon...</h1>
      </div>
    </motion.div>
  );
}

export default GiftCards;
